import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { EnvironmentToken } from '@jump-tech-frontend/app-config';
import { RelayEnvironment } from '@jump-tech-frontend/domain';
import { firstValueFrom } from 'rxjs';
import { TextDetection } from './ocr.model';

@Injectable({ providedIn: 'root' })
export class OcrService {
  private readonly http = inject(HttpClient);
  private readonly environment = inject<RelayEnvironment>(EnvironmentToken);

  public recognise(image: string): Promise<TextDetection[]> {
    return firstValueFrom(
      this.http.post<TextDetection[]>(
        this.environment.apiOcrRekognitionUrl,
        { image },
        { headers: { 'Content-Type': 'application/json' } }
      )
    );
  }
}
